import angular from 'angular';
import { AdvancedSearchComponent } from './advanced-search.component';
import niceUrlService from './../../niceUrl/nice-url.module';


const MODULE_NAME = 'advancedSearch';

export default angular.module(MODULE_NAME, [niceUrlService]).component('advancedSearch', AdvancedSearchComponent).name;


